import React, { Fragment, useRef } from 'react'

import { useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'

import { PageBlock } from '../'
import {
    Meta,
    Block,
    Container,
    ContentWrap,
    Row,
} from '../Common'


const Home = () => {
    const { page } = useSelector(state => state.content, shallowEqual)
    const content = useRef()

    return (
        <Fragment>
            <Meta page={page} />
            <HomeContainer>
                <Row>
                    <ContentWrap ref={content}>
                        {page.blocks && page.blocks.map((pageBlock, i) =>
                            <Block key={i.toString()} marginbottom={30}>
                                <PageBlock pageBlock={pageBlock} url={page.url} />
                            </Block>
                        )}
                    </ContentWrap>
                </Row>
            </HomeContainer>
        </Fragment>
    )
}

const HomeContainer = styled(Container)`

`

export default Home
